module.exports = __webpack_public_path__ + "img/teacher_men_40.cf5c8260.png";